export default "__VITE_ASSET__BX28g$rR__"